export default {
  types: {
    work: "Work",
    expression: "Expression",
    manifestation: "Manifestation",
    item: "Item",
    person: "Person",
    collective_agent: "Collective agent",
    nomen: "Nomen",
    place: "Place",
    concept: "Concept",
    prize: "Prize",
    prize_season: "Prize season",
  },
  typesPlural: {
    work: "Works",
    expression: "Expressions",
    manifestation: "Manifestations",
    item: "Items",
    person: "Persons",
    collective_agent: "Collective agents",
    nomen: "Nomens",
    place: "Places",
    concept: "Concepts",
    prize: "Prizes",
    prize_season: "Prize seasons",
  },
  unionMember: "Writers Union member",
  tabs: {
    description: "Description",
    relations: "Relations",
    marc: "MARC",
    export: "Export / cite",
    report: "Report an error",
  },
  attributes: "Attributes",
  attr: {
    title: "Title",
    subtitle: "Subtitle",
    responsibility: "Statement of responsibility",
    edition: "Edition statement",
    publication_place: "Place of publication",
    publisher_name: "Publisher",
    publication_year: "Year of publication",
    extent: "Extent",
    illustrative_content: "Illustrative content",
    dimensions: "Dimensions",
    print_run: "Print run",
    manufacturer_name: "Manufacturer / printer",
    series_title: "Series",
    series_number: "Series number",
    age_rating: "Age rating",
    annotation: "Annotation",
    language: "Language",
    form: "Form",
    original_language: "Original language",
    date_created: "Date created",
    content_type: "Content type",
    isbn: "ISBN",
    holding_library: "Holding library",
    collection_code: "Collection",
    call_number: "Call number",
    birth_date: "Birth date",
    death_date: "Death date",
    gender: "Gender",
    birth_place: "Birth place",
    region: "Region",
    biography: "Biography",
    kind: "Kind",
    place: "Place",
    founded: "Founded",
    country: "Country",
    scheme: "Scheme",
    notation: "Notation",
    level: "Level",
    organizer: "Organizer",
    note: "Note",
    year: "Year / season",
    awarded_year: "Award year",
  },
  scheme: {
    isbn: "ISBN",
    issn: "ISSN",
    doi: "DOI",
    udc: "UDC",
    bbk: "BBK",
    viaf: "VIAF",
    isni: "ISNI",
    rsl_auth: "RSL authority",
    nlr_auth: "NLR authority",
    rsl_reg: "RSL registration no.",
    nbr_bib: "NBR record id",
    rsl_bib: "RSL record id",
    nlr_bib: "NLR record id",
    excel_row: "Excel row",
  },
  nomens: "Names and titles",
  identifiers: "Identifiers",
  permalink: "Permalink",
  iri: "IRI",
  source: "Source",
  updated: "Updated",
  relationsEmpty: "No relations.",
  incoming: "Incoming",
  outgoing: "Outgoing",
  recommendations: "Similar records",
  marcLeader: "Leader",
  marcEmpty: "MARC record is unavailable.",
  citation: "Bibliographic citation",
  citationStyle: "Style",
  exportFormat: "Export format",
  exportAction: "Download file",
  reportMessage: "Error description",
  reportField: "Field (optional)",
  reportEmail: "Contact email",
  reportSent: "Report submitted. Thank you!",
  notFound: "Record not found",
  addToCollection: "Add to collection",
  pickCollection: "Choose a collection",
  dossierWork: "Work",
  dossierWorks: "Works",
  dossierEdition: "This edition",
  dossierEditions: "Editions",
  dossierOtherEditions: "Other editions",
  dossierCreators: "Authors and contributors",
  dossierSubjects: "Subjects",
  dossierPrizes: "Prizes",
  dossierNominees: "Nominees",
  dossierPublishers: "Publisher",
  dossierOther: "More links",
  dossierMore: "MARC, export and error report",
  graphTitle: "Record graph",
  graphHint: "Click a node to show its links",
  graphExpanding: "Loading links…",
  graphExpandEmpty: "No further links.",
  graphExpandError: "Could not load links.",
  graphPath: "Path through links",
  graphHome: "Back to start",
  graphCentered: "Centered on {{label}}",
  graphShownOf: "Showing {{shown}} of {{total}}",
  graphOpen: "Open record",
  graphMore: "More links: {{count}}",
}
